import type { AIPluginOptions } from '@atlassian/editor-plugin-ai/aiPluginType';

interface Props {
	options: AIPluginOptions;
}

export function aiPluginOptions({ options }: Props): AIPluginOptions {
	// Options not declared here as they are all nested inside hooks, starting with `useEditorPluginAIOptions`.
	return options;
}
